/**
 * Priority Color System
 * 
 * Single source of truth for priority colors used across all processes.
 * Ensures consistent color usage for high/medium/low priorities.
 */

export const PRIORITY_COLORS = {
  high: 'rgba(255, 0, 0, 0.6)',
  medium: 'rgba(255, 200, 0, 0.6)',
  low: 'rgba(0, 200, 0, 0.6)'
} as const;

export const PRIORITY_COLORS_SUBTLE = {
  high: 'rgba(255, 0, 0, 0.4)',
  medium: 'rgba(255, 200, 0, 0.4)',
  low: 'rgba(0, 200, 0, 0.4)'
} as const;

export type Priority = 'low' | 'medium' | 'high';

/**
 * Get priority color
 */
export function getPriorityColor(priority: Priority, subtle: boolean = false): string {
  const colors = subtle ? PRIORITY_COLORS_SUBTLE : PRIORITY_COLORS;
  return colors[priority] || colors.low;
}

/**
 * Get priority color for event bars (calendar events)
 */
export function getEventBarColor(priority?: Priority): string {
  if (!priority) return 'rgba(255, 255, 255, 0.4)';
  return PRIORITY_COLORS[priority] || PRIORITY_COLORS.low;
}

/**
 * Get priority color for indicators (small squares)
 */
export function getPriorityIndicatorColor(priority: Priority): string {
  return PRIORITY_COLORS_SUBTLE[priority] || PRIORITY_COLORS_SUBTLE.low;
}

